<template>
  <main class="auth-page auth-page-simple">
    <section class="auth-showcase">
      <router-link to="/" class="brand" aria-label="123Mail">
        <img src="@/assets/img/icon.png" alt="" />
        <span>123MAIL</span>
      </router-link>
      <div class="showcase-copy">
        <span class="eyebrow">Acesso seguro</span>
        <h1>Recupere seu acesso com tranquilidade.</h1>
        <p>Enviaremos as instruções para o e-mail cadastrado na sua conta.</p>
      </div>
      <p class="showcase-footer">Seus dados continuam protegidos.</p>
    </section>

    <section class="auth-panel">
      <div class="auth-card compact-card">
        <div class="mobile-brand">
          <img src="@/assets/img/icon.png" alt="" />
          <strong>123MAIL</strong>
        </div>

        <router-link to="/" class="back-link"><i class="fas fa-arrow-left"></i> Voltar para o login</router-link>

        <div v-if="sent" class="success-state" role="status">
          <div class="success-icon"><i class="far fa-envelope"></i></div>
          <span class="eyebrow">E-mail enviado</span>
          <h2>Confira sua caixa de entrada</h2>
          <p>Enviamos as instruções de recuperação para <strong>{{ email }}</strong>.</p>
          <router-link to="/" class="submit-button">Voltar para o login <i class="fas fa-arrow-right"></i></router-link>
          <button class="text-button" type="button" @click="sent = false">Usar outro e-mail</button>
        </div>

        <template v-else>
          <header class="auth-header">
            <span class="eyebrow">Recuperação de senha</span>
            <h2>Esqueceu sua senha?</h2>
            <p>Informe seu e-mail e enviaremos um link para você criar uma nova senha.</p>
          </header>

          <form @submit.prevent="sendRecoveryPassword" novalidate>
            <div class="field">
              <label for="recovery-email">E-mail cadastrado</label>
              <div class="input-shell">
                <i class="far fa-envelope"></i>
                <input id="recovery-email" v-model="email" type="email" autocomplete="email" placeholder="voce@empresa.com.br" />
              </div>
            </div>
            <button type="submit" class="submit-button" :disabled="loading">
              <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
              <span>{{ loading ? 'Enviando...' : 'Enviar link de recuperação' }}</span>
              <i v-if="!loading" class="fas fa-arrow-right"></i>
            </button>
          </form>
          <p class="support-note"><i class="fas fa-shield-alt"></i> O link expira por segurança e só pode ser utilizado uma vez.</p>
        </template>
      </div>
    </section>
  </main>
</template>

<script>

import { recoveryPassword } from "@/services/auth";


export default {
    name: 'RecoveryPassword',
    data() {
        return {
            email: "",
            loading: false,
            sent: false
        }
    },
    methods: {
        sendRecoveryPassword() {
        if (this.loading) return;
        if (!this.email) {
            return this.$toast.error({
            title: "Erro",
            message: "Você precisa preencher o e-mail"
            });
        }
        this.loading = true;
        recoveryPassword({ email: this.email.trim() })
            .then(() => {
                this.sent = true;
                this.$toast.success({
                    title: "Sucesso",
                    message: "Foi enviado um e-mail para a recuperação da senha"
                });
            })
            .catch(error => {
                if (error && error.message === "request-canceled") {
                    return;
                }

                return this.$toast.error({
                    title: "Erro",
                    message: "Ocorreu um erro interno na sua solicitação"
                });
            })
            .finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./auth-shared";
</style>
